<ip-shared-translucent-card class='block w-11 mx-auto'>
  <div id='time-line-container'>
    <div id='lg-progress'>
      <div id='step-nav'>
        @for (step of steps!;track step.label;let i=$index) {
          <div [ngClass]='{ "validStep" : i <= stepNo, "isActive": isActive(i)}'>
            <a [routerLink]='getRouterLink(step)' [queryParams]='step.queryParams' [attr.tabindex]='getItemTabIndex(step)'
               role='tab' [attr.aria-selected]='i === stepNo'>
              {{ i + 1 }} <p>{{ step.label }}</p>
            </a>
          </div>
        }

        <svg id='line-progress' height='7'>
          <g id='progress-container'>
            <line x1='0' y1='50%' x2='100%' y2='50%' stroke-width='1' />
          </g>
          <g id='progress-content'>
            <line x1='0' y1='50%' x2='100%' y2='50%' stroke-width='1' fill='transparent' stroke-dasharray='0%'
                  stroke-dashoffset='0%' [ngStyle]="{'transform':'translateX('+ progressValue +'%)'}" />
          </g>
        </svg>
      </div>
    </div>

    <div id='xs-progress'>
      <span class='step-display'>{{ stepNo + 1 }}</span>

      <svg id='svg' width='100' height='100'>
        <circle [attr.r]='radius' cx='50' cy='50' fill='transparent' [attr.stroke-dasharray]='strokeDashOffset'
                stroke-dashoffset='0'></circle>
        <circle #bar id='bar' [attr.r]='radius' cx='50' cy='50' fill='transparent'
                [attr.stroke-dasharray]='strokeDashOffset' [attr.stroke-dashoffset]='strokeDashOffset'></circle>
      </svg>

      <h3 class='title'>
        {{ steps[stepNo].label }}
        <br>
        <p><i class='pi pi-check-circle'></i>{{ '\t' + stepRapport + '% completat' }}</p>
      </h3>
    </div>
  </div>
</ip-shared-translucent-card>
